export const passwordUpperCaseVerification = password =>
  password && password.length >= 1 && !password.match(/(?=.*[A-Z])/);

export const passwordDigitVerification = password =>
  password && password.length >= 1 && !password.match(/(?=.*\d)/);

export const passwordLengthVerification = password =>
  password && password.length >= 1 && password.length < 8;
